"use client";

import { ROUTER_PATH } from "@config/router";
import React from "react";
import { ThemeChip } from "./ThemeChip";
import type { ThemeSectionProps } from "./types";
import { cn } from "utils";
import { useShellRouter } from "@hooks/useShellAwareRouter";

/**
 * 主题区块组件 - 用于显示主题标签列表
 */
export const ThemeSection: React.FC<ThemeSectionProps> = ({
  title,
  themes,
  viewAllText = "View all",
  onViewAll,
  className,
  showAll: _showAll = false,
  type,
  onClose,
}) => {
  const router = useShellRouter();
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {title && (
        <h3
          aria-label="Theme Section h3"
          data-openreplay-label="home_themesection_h3"
          id="sem-theme-section-h3"
          className="title_s text-content_tertiary"
        >
          {title}
        </h3>
      )}
      <div className="flex flex-wrap gap-3">
        {themes.map((theme, index) => (
          <ThemeChip
            data-openreplay-label="home_themesection_themechip"
            key={theme.id || `${theme.source_link}-${index}`}
            theme={theme}
            onClick={() => {
              //TOTO: 区分美股/港股
              if (type === "stock") {
                router.push(
                  `${theme.market === "US" ? ROUTER_PATH.RADAR_US_STOCK : ROUTER_PATH.RADAR_HK_STOCK}/${theme.short_name}`,
                );
                onClose?.();
                return;
              }
              router.push(`/market/${type}/${theme.short_name}`);
              onClose?.();
            }}
          />
        ))}
      </div>
      {onViewAll && (
        <button
          aria-label="Theme Section"
          data-openreplay-label="home_themesection_click"
          id="btn-theme-section"
          className="body_medium_s text-content_brand_primary text-center cursor-pointer hover:opacity-80 transition-opacity w-fit"
          onClick={onViewAll}
        >
          {viewAllText}
        </button>
      )}
    </div>
  );
};
